import React, { useEffect } from "react";
import { Box, Modal, Typography } from "@mui/material";

const AlertModal = ({ open, onClose, message, severity, duration }) => {
  const modalStyles = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    textAlign: "center",
  };

  const severityColors = {
    info: "primary.main",
    success: "success.main",
    warning: "warning.main",
    error: "error.main",
  };

  useEffect(() => {
    if (open && duration) {
      const timeout = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timeout);
    }
  }, [open, duration, onClose]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiBackdrop-root": {
          backdropFilter: "blur(10px)",
        },
      }}
    >
      <Box sx={modalStyles}>
        <Typography
          variant="h4"
          color={severityColors[severity] || "text.primary"}
        >
          {severity.toUpperCase()}
        </Typography>
        <Typography variant="body1" sx={{ mt: 2, mb: 4 }}>
          {message}
        </Typography>
      </Box>
    </Modal>
  );
};

export default AlertModal;
